import { render, staticRenderFns } from "./SalesHistoryV2.vue?vue&type=template&id=36bcaeaa&scoped=true"
import script from "./SalesHistoryV2.vue?vue&type=script&lang=js"
export * from "./SalesHistoryV2.vue?vue&type=script&lang=js"
import style0 from "./SalesHistoryV2.vue?vue&type=style&index=0&id=36bcaeaa&prod&lang=css"
import style1 from "./SalesHistoryV2.vue?vue&type=style&index=1&id=36bcaeaa&prod&scoped=true&lang=css"
import style2 from "./SalesHistoryV2.vue?vue&type=style&index=2&id=36bcaeaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bcaeaa",
  null
  
)

export default component.exports